import { ForwardedRef, forwardRef } from 'react';
import styles from './FileMessageLink.module.scss';
import { Icon, Text } from 'components';

type Props = {
  link: string;
  text: string;
};

export const FileMessageLink = forwardRef(({ link, text }: Props, ref: ForwardedRef<HTMLAnchorElement>) => {
  return (
    <a href={link} download={text} className={styles.link} target="_self" ref={ref}>
      <Icon name="File" className={styles.fileIcon} />
      <Text type="subtitle2" className={styles.linkText}>
        {text}
      </Text>
      <Icon name="CloudDownload" />
    </a>
  );
});

FileMessageLink.displayName = 'FileMessageLink';
